import React, { useState } from "react";
import Collapsible from "react-collapsible";
import Icon from "sulu-admin-bundle/components/Icon";
import Avatar from "../../../../svgs/Avatar";
import CardEvent from "./CardEvent";
import style from "./SidePanel.scss";
import Spinner from "./../../Spinner";
import overrides from "./../../../../css/customization.scss";
import PlayerButton from "./PlayerButton";
import BigViewIcon from "../../../../svgs/BigViewIcon";
import SmallViewIcon from "../../../../svgs/SmallViewIcon";

import fonts from "../../../../css/components/fonts.scss";

export default (props) => {
    const [smallView, setSmallView] = useState(false);
    const viewIcons = (
        <div className={style.iconsBlock}>
            <span
                className={style.iconWrap}
                onClick={(e) => {
                    e.stopPropagation();
                    setSmallView(false);
                }}
            >
                <BigViewIcon active={!smallView} />
            </span>
            <span
                className={style.iconWrap}
                onClick={(e) => {
                    e.stopPropagation();
                    setSmallView(true);
                }}
            >
                <SmallViewIcon active={smallView} />
            </span>
        </div>
    );

    // for displaying separately
    const goalKeepers = props.players.filter(
        (player) => player?.isGoalkeeper || player?.isSubstituteGoalkeeper
    );
    const regularPlayers = props.players.filter(
        (player) => !player?.isGoalkeeper && !player?.isSubstituteGoalkeeper
    );

    const renderPlayers = (players) => (
        <div
            className={`${style.playerGrid} ${
                smallView ? style.playerGridSmall : ""
            }`}
        >
            {props.players.length > 0 ? (
                players.map((player, index) => (
                    <PlayerButton
                        key={player.id}
                        player={player}
                        parentProps={props}
                        smallView={smallView}
                    />
                ))
            ) : (
                <Spinner />
            )}
        </div>
    );

    return (
        <aside
            className={
                props.status === 4
                    ? `${style.sideColumn} ${style.disabled}`
                    : style.sideColumn
            }
        >
            {/*tim*/}
            <div className={style.sideColumnTeam}>
                {props.side?.logo ? <img src={props.side.logo} /> : <Spinner />}
                <p className={fonts.fs36}>{props.side?.teamName}</p>
            </div>
            <div
                className={`${style.collapsibleContainer} ${overrides.fontRoboto}`}
            >
                <Collapsible
                    trigger={
                        <div className={style.collapsibleWrapper}>
                            <span className={fonts.fs16}>
                                <Avatar />
                                Spielerinnen
                            </span>
                            <div className={style.collapsibleIconsWrap}>
                                {viewIcons}
                                <Icon name="su-angle-down" />
                            </div>
                        </div>
                    }
                    triggerStyle={{ display: "block", cursor: "pointer" }}
                    classParentString={style.collapsible}
                    triggerOpenedClassName={style.collapsible__open}
                >
                    {renderPlayers(goalKeepers)}
                    {renderPlayers(regularPlayers)}
                </Collapsible>
            </div>
            {/*staff*/}
            <div
                className={`${style.collapsibleContainer} ${overrides.fontRoboto}`}
            >
                <Collapsible
                    trigger={
                        <div className={style.collapsibleWrapper}>
                            <span className={fonts.fs16}>
                                <Avatar />
                                Staff
                            </span>
                            <Icon name="su-angle-down" />
                        </div>
                    }
                    triggerStyle={{ display: "block", cursor: "pointer" }}
                    classParentString={style.collapsible}
                    triggerOpenedClassName={style.collapsible__open}
                >
                    <div className={style.playerGrid}>
                        {props.staff.length > 0 ? (
                            props.staff.map((staff, index) => (
                                <PlayerButton
                                    key={staff.id}
                                    player={staff}
                                    parentProps={props}
                                />
                            ))
                        ) : (
                            <Spinner />
                        )}
                    </div>
                </Collapsible>
            </div>

            {/*kartoni*/}
            <div
                className={`${style.collapsibleContainer} ${overrides.fontRoboto} ${style.cards}`}
            >
                <Collapsible
                    trigger={
                        <div className={style.collapsibleWrapper}>
                            <span className={fonts.fs16}>Karten</span>
                            <Icon name="su-angle-down" />
                        </div>
                    }
                    triggerStyle={{ display: "block", cursor: "pointer" }}
                    classParentString={style.collapsible}
                    triggerOpenedClassName={style.collapsible__open}
                >
                    <CardEvent events={props.events} />
                </Collapsible>
            </div>
        </aside>
    );
};
